import { addGAEventTracking } from '!/common/helpers';
import PropTypes from 'prop-types';
import WidgetUtils from '../WidgetUtils';
import { getLocale, sendGAEvent } from '!/common/helpers';
import { useState, useEffect } from 'react';

const WidgetContainer = props => {
  const { title, values, mobileOnly = false, noscript = true} = props;
  const { showUtils = false, name, open, toggleWidgetOpenState } = props;
  const { widgetIndex, widgetsOpenState } = props;

  const isHorizontal = (typeof document !== 'undefined' && document.body.classList.contains("horizontal-navigation"));

  const toggleAllOptions = () => {
    const targetContainer = document.querySelector(`details[data-toggle="${name}"]`);
    targetContainer.classList.toggle('widget--show-all');
  };

  const onclick = e => {
    sendGAEvent('Search Filter', `Section ${e.currentTarget.parentNode.open ? 'opened' : 'closed'}`, title);
    e.preventDefault();
    toggleWidgetOpenState();
  };

  const x = e => {
    e.preventDefault();
    toggleWidgetOpenState();
  };

  const valuesSelected = ((values && values[name]) && values[name].length > 0) ? values[name].length : null;
  return (
    <details
      open={ name== 'categories' ? true : (widgetsOpenState !== undefined && widgetIndex !== undefined && widgetsOpenState[widgetIndex]) || false }
      data-selected={ valuesSelected }
      className={`accordion accordion--icon details details--search widget ${mobileOnly ? ' show-for-small' : ''}`}
      data-toggle={name}
    >
      <summary onClick={onclick}>
        <div className="accordion__header">
          <b>{getLocale(title)}</b>
          {/* display the currently selected values for mobile */}
          {valuesSelected && (
              <small aria-label={getLocale('Selected Filters')}>
                {title === 'Price' ? values[name].join('-') : values[name].join(', ')}
              </small>
            )}
          </div>
      </summary>

      <div className={`accordion__content ${showUtils ? 'accordion__content--wide' : ''}`}>
        <div onClick={x} className="accordion__close-x"></div>
        <h3 className="accordion__content-title">{getLocale(title)} { valuesSelected ? <span>({valuesSelected})</span> : ''} </h3>
        { valuesSelected && <button className="accordion__remove-all" onClick={_ => props.update(name, [])}>Alle Entfernen</button> }
        {/* render search, toggle button */}
        <div className={`accordion__content-children`}>
          <WidgetUtils title={title} toggle={toggleAllOptions} showUtils={showUtils}>
            {props.children}
          </WidgetUtils>
        </div>

        {/* displays a submit button if js fails */}
        {noscript && (
          <noscript>
            <button type="submit">{getLocale('Filter')}</button>
          </noscript>
        )}
      </div>
    </details>
  );
};

WidgetContainer.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  values: PropTypes.object,
  mobileOnly: PropTypes.bool,
  noscript: PropTypes.bool,
  showUtils: PropTypes.bool
};

export default WidgetContainer;
